var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 930.333,
    height: 370,
    viewBox: "0 0 930.333 370",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-logo_-_color_with_tagline_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 930.333,
    height: 370
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_-_color_with_tagline_",
    "data-name": "logo - color with tagline ",
    clipPath: "url(#clip-logo_-_color_with_tagline_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clinnect_logo",
    transform: "translate(36.566 22.981)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 5.5,
    height: 40,
    transform: "translate(460.6 278.5)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M0,170.2c0-43.1,32.9-74.5,77.2-74.5,22.5,0,42,7.7,55.3,22.7L119,131.5c-11.2-11.8-25-17.3-41-17.3-32.9,0-57.2,23.7-57.2,56S45.1,226.1,78,226.1c16,0,29.8-5.6,41-17.5l13.5,13.1c-13.3,15-32.9,22.9-55.5,22.9C32.9,244.6,0,213.2,0,170.2Z",
    fill: "#1193ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M159.9,88.6h20V242.9h-20Z",
    fill: "#1193ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M218.6,132.7h20V242.9h-20Z",
    fill: "#1193ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M645.6,194.5H556.2c2.5,19.4,18.1,32.2,39.9,32.2,12.9,0,23.7-4.4,31.8-13.3l11,12.9c-10,11.6-25.2,17.9-43.5,17.9-35.6,0-59.3-23.5-59.3-56.4,0-32.7,23.5-56.2,55.3-56.2s54.5,22.9,54.5,56.8A31.953,31.953,0,0,1,645.6,194.5Zm-89.4-14.3h70.7c-2.1-18.5-16-31.6-35.4-31.6C572.4,148.5,558.3,161.4,556.2,180.2Z",
    fill: "#1193ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M664.2,187.8c0-32.9,24.3-56.2,58.2-56.2,19.8,0,36.2,8.1,44.9,23.5l-15.2,9.8c-7.1-10.8-17.9-15.8-29.9-15.8-21.6,0-37.9,15.2-37.9,38.7,0,23.9,16.2,38.9,37.9,38.9,12.1,0,22.9-5,30-15.8l15.2,9.6c-8.7,15.4-25.2,23.7-44.9,23.7C688.5,244.2,664.2,220.7,664.2,187.8Z",
    fill: "#1193ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M857.2,236.5c-6,5.2-15.2,7.7-24.1,7.7-22.3,0-34.9-12.3-34.9-34.5V149.2H779.5V132.7h18.7V108.6h20v24.1h36.3v16.4l-36.3.1v59.7c0,11.9,6.2,18.5,17.3,18.5a25.259,25.259,0,0,0,15.6-5.2Z",
    fill: "#1193ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M285.9,242.9V188.3c0-33.9,20.5-47.7,43.2-47.7h-.8c22.6,0,43.2,13.8,43.2,47.7v54.6",
    fill: "none",
    stroke: "#1193ad",
    strokeMiterlimit: 10,
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M420.5,242.9V188.3c0-33.9,20.5-47.7,43.2-47.7h-.8c22.7,0,43.2,13.8,43.2,47.7v54.6",
    fill: "none",
    stroke: "#f26419",
    strokeMiterlimit: 10,
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 13.5,
    cy: 13,
    rx: 13.5,
    ry: 13,
    transform: "translate(215.1 85.5)",
    fill: "#f26419"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 33.7,
    height: 14.3,
    transform: "translate(410.6 228.6)",
    fill: "#f26419"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 33.7,
    height: 14.3,
    transform: "translate(482.2 228.6)",
    fill: "#f26419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M462.9,140.7c.8-12.3,1.7-49.9-23.4-84.2C412,19,360.9-4.1,312.5,8.5c-47.3,12.3-70.7,53.1-75,60.9a121.528,121.528,0,0,0-11.9,31.7",
    fill: "none",
    stroke: "#f26419",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M519.6,313.1l3.3-3.5a17.555,17.555,0,0,0,12,4.9c5.7,0,9.1-2.6,9.1-6.5,0-4.1-3.2-5.4-7.3-7l-6.3-2.5c-4.1-1.6-8.8-4.4-8.8-10.3,0-6.1,5.8-10.6,13.7-10.6a18.52,18.52,0,0,1,12.8,4.9l-2.9,3.3a14.746,14.746,0,0,0-9.9-3.7c-4.9,0-8.1,2.3-8.1,5.8,0,3.8,3.8,5.3,7.2,6.6l6.2,2.5c5,2,9,4.7,9,10.7,0,6.3-5.7,11.3-14.9,11.3A22.031,22.031,0,0,1,519.6,313.1Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M561.9,278.4H587v4.3H567.4v12.5H584v4.3H567.5V314h20.2v4.3H561.9Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M598.1,298.4c0-12.9,8.3-20.7,19.3-20.7a17.291,17.291,0,0,1,12,4.9l-3,3.3a12.6,12.6,0,0,0-8.9-3.8c-8.2,0-13.7,6.2-13.7,16.1,0,10,5.2,16.3,13.5,16.3a13.616,13.616,0,0,0,10.1-4.5l3,3.2A17.284,17.284,0,0,1,617,319C606.2,319,598.1,311.3,598.1,298.4Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M642,301.8V278.4h5.5V302c0,9.6,4.4,12.6,10.1,12.6,5.8,0,10.3-3,10.3-12.6V278.4h5.3v23.4c0,12.8-6.8,17.2-15.7,17.2S642,314.6,642,301.8Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M688.7,278.4h13.7c8.9,0,15.3,2.9,15.3,11.2,0,8-6.4,11.8-15.3,11.8h-8.1v16.9h-5.5V278.4Zm12.8,18.9c6.8,0,10.5-2.5,10.5-7.7,0-5.3-3.7-7.1-10.5-7.1h-7.3v14.8Zm-.3,2.7,4.3-2.6,13.3,20.9h-6.3Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M730.1,278.4h25.1v4.3H735.6v12.5h16.5v4.3H735.6V314h20.2v4.3H730l.1-39.9Z",
    fill: "#5c5c5c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M97,278.4h25.1v4.3H102.5v12.5H119v4.3H102.5V314h20.2v4.3H97Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M135.6,278.4h25.1v4.3H141.1v13.5h16.6v4.3H141.1v17.9h-5.5Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M172.1,278.4h25.1v4.3H177.6v13.5h16.6v4.3H177.6v17.9h-5.5Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M208.6,278.4h5.5v39.9h-5.5Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M227.2,298.4c0-12.9,8.3-20.7,19.3-20.7a17.291,17.291,0,0,1,12,4.9l-3,3.3a12.6,12.6,0,0,0-8.9-3.8c-8.2,0-13.7,6.2-13.7,16.1,0,10,5.2,16.3,13.5,16.3a13.616,13.616,0,0,0,10.1-4.5l3,3.2a17.284,17.284,0,0,1-13.4,5.8C235.3,319,227.2,311.3,227.2,298.4Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M271.3,278.4h5.5v39.9h-5.5Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M292.4,278.4h25.1v4.3H297.9v12.5h16.5v4.3H297.9V314h20.2v4.3H292.3l.1-39.9Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M331.1,278.4h5.7l15.8,25.1,4.7,8.3h.3c-.3-4-.7-8.5-.7-12.7V278.4h5.3v39.9h-5.7l-15.8-25.1L336,285h-.3c.3,4,.7,8.3.7,12.5v20.9h-5.3v-40Z",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M386.8,282.7H373.6v-4.3h31.9v4.3H392.3v35.6h-5.5V282.7Z",
    fill: "#5c5c5c"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cfa0a005793a52ed3ad27e575d000029.svg";
export { ForwardRef as ReactComponent };